import { IconTypes } from '@eika/icon';

import { KortbetjeningText } from '@hooks/use-text';

import InstructionStepType, { InstructionStepNoIconType } from './types';

export const getInstructionStepsPartOne = ({
    googleWalletInstructionStepsPartOneStepOne,
    googleWalletInstructionStepsPartOneStepTwo,
    googleWalletInstructionStepsPartOneStepThree,
}: KortbetjeningText): InstructionStepType[] => [
    {
        icon: IconTypes.MOBIL_24,
        text: googleWalletInstructionStepsPartOneStepOne,
    },
    {
        icon: IconTypes.SOEK_24,
        text: googleWalletInstructionStepsPartOneStepTwo,
    },
    {
        icon: IconTypes.NEDLASTING_24,
        text: googleWalletInstructionStepsPartOneStepThree,
    },
];
export const getInstructionStepsPartTwo = ({
    googleWalletInstructionStepsPartTwoStepOne,
    googleWalletInstructionStepsPartTwoStepTwo,
    googleWalletInstructionStepsPartTwoStepThree,
}: KortbetjeningText): InstructionStepType[] => [
    {
        icon: IconTypes.BANKKORT_24,
        text: googleWalletInstructionStepsPartTwoStepOne,
    },
    {
        icon: IconTypes.PLUSS_24,
        text: googleWalletInstructionStepsPartTwoStepTwo,
    },
    {
        icon: IconTypes.INFO_24,
        text: googleWalletInstructionStepsPartTwoStepThree,
    },
];
export const getInstructionStepsPartThree = ({
    googleWalletInstructionStepsPartThreeStepOne,
    googleWalletInstructionStepsPartThreeStepTwo,
    googleWalletInstructionStepsPartThreeStepThree,
}: KortbetjeningText): InstructionStepType[] => [
    {
        icon: IconTypes.MOBIL_24,
        text: googleWalletInstructionStepsPartThreeStepOne,
    },
    {
        icon: IconTypes.OYE_24,
        text: googleWalletInstructionStepsPartThreeStepTwo,
    },
    {
        icon: IconTypes.CHECKMARK_TIL_SIRKEL_24,
        text: googleWalletInstructionStepsPartThreeStepThree,
    },
];

export const getInstructionStepsPartFour = ({
    googleWalletInstructionStepsPartFourStepOne,
    googleWalletInstructionStepsPartFourStepTwo,
}: KortbetjeningText): InstructionStepNoIconType[] => [
    {
        text: googleWalletInstructionStepsPartFourStepOne,
    },
    {
        text: googleWalletInstructionStepsPartFourStepTwo,
    },
];
